

import { useContext, useEffect, useState, } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import { CartContext } from '../../context/cartContext/CartContext'
import { actionTypes, currentStatusEnvois, statusEnvois, typeDeliveries, typeEnvois, typeRamassages, wilayas } from '../../data';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import { useNavigate, useParams } from 'react-router-dom';
import CartPaginationComponent from '../../components/paginationComponent/CartPaginationComponent';
import { clearCart, removeFromCart, restartCart } from '../../context/cartContext/CartActions';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent';
import ModalComponent from '../../components/modalComponent/ModalComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { addAction, addActioneEtat, getOneCartEnvoie } from '../../context/cartContext/apiCalls';
import { DeliveryContext } from '../../context/deliveryContext/DeliveryContext';
import { getLivreurs, getTransporteurs } from '../../context/deliveryContext/apiCalls';
import './createAction.css';
import FormTextArea from '../../components/formTextArea/FormTextArea';
import { AuthContext } from '../../context/authContext/AuthContext';
import FormRadio from '../../components/formRadio/FormRadio';

function CreateAction() {
    const { dispatch, cart, message, isFetchingAdd, errorAdd, messageEtat, isFetchingEtatAdd, errorEtatAdd, isFetchingGetOne, errorGetOne } = useContext(CartContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { dispatch: dispatchDelivery, transporteurs, livreurs } = useContext(DeliveryContext);
    const { user } = useContext(AuthContext);
    const [tinyCart, setTinyCart] = useState([]);

    const navigate = useNavigate();
    const { page = 1 } = useParams();
    const [pageSize, setPageSize] = useState(10);
    const [pages, setPages] = useState(Math.ceil(cart.length / pageSize));
    const [errorBox, setErrorBox] = useState("");
    const [actionType, setActionType] = useState(actionTypes[0]);

    const [addDescription, setAddDescription] = useState("");
    const [addTypeActionEnvoie, setAddTypeActionEnvoie] = useState({ nom: "Choisir Action", id: 0, });
    const [addAgenceDepart, setAddAgenceDepart] = useState({ nom: "Choisir Agence", id: 0, });
    const [addAgenceArrived, setAddAgenceArrived] = useState({ nom: "Choisir Agence Arrivé", id: 0, });
    const [addTransporteur, setAddTransporteur] = useState({ nom: "Choisir Transporteur", id: 0, });
    const [addLivreur, setAddLivreur] = useState({ nom: "Choisir Livreur", id: 0, });
    const [actionErrorBox, setActionErrorBox] = useState("");

    const [addNewEnvoieStatus, setAddNewEnvoieStatus] = useState({ nom: "Choisir nouveau Etat", id: 0, });
    const [addMotifNewEnvoieStatus, setAddMotifNewEnvoieStatus] = useState("");
    const [actionEtatErrorBox, setActionEtatErrorBox] = useState("");

    const [codebarCart, setCodebarCart] = useState("");
    const [modalAddActionActive, setModalAddActionActive] = useState(false);
    const [modalViderPanierActive, setModalViderPanierActive] = useState(false);

    useEffect(() => {
        setTinyCart(cart.slice((page - 1) * pageSize, page * pageSize));
    }, [pageSize, page, cart])

    useEffect(() => {
        setPages(Math.ceil(cart.length / pageSize));
        setErrorBox('');
        setCodebarCart('');
    }, [pageSize, cart])

    // useEffect(()=>{
    //     cart.map(item => {
    //         if(item.type === 2 || item.type === 8){
    //             if(!item.Entreprise){
    //                 setSumCost(prev => prev + item.cost)
    //             }
    //         }else if(item.type === 5 || item.type === 6){

    //         }
    //     })
    // }, [cart])

    useEffect(() => {
        if (errorAdd != false) {
            setActionErrorBox(errorAdd);
        }
    }, [errorAdd])

    useEffect(() => {
        if (errorGetOne != false) {
            setErrorBox(errorGetOne);
        }
    }, [errorGetOne])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
        getLivreurs(dispatchDelivery);
        getTransporteurs(dispatchDelivery);
        dispatch(restartCart());  // just added lately
    }, [])

    useEffect(() => {
        (user.role !== 1 && user.role !== 2) && setAddAgenceDepart(agencesByWilaya.filter(item => item.id === user.agence)[0])
    }, [agencesByWilaya])

    useEffect(() => {
        if (message !== "") {
            dispatch(restartCart());
            navigate('/actions');
        }
        if (messageEtat !== "") {
            dispatch(restartCart());
            navigate('/actions');
        }
    }, [message, messageEtat])

    // New Envoie Status
    useEffect(() => {
        if (errorEtatAdd != false) {
            setActionEtatErrorBox(errorEtatAdd);
        }
    }, [errorEtatAdd])

    function checkSize(value) {
        if (value.length > 11)
            return value.substring(0, 8) + '...';
        else
            return value;
    }

    function viderPanier() {
        dispatch(clearCart());
        setModalViderPanierActive(false)
    }

    function removeOneItem(id) {
        dispatch(removeFromCart(id));
    }

    // function modalActiveHandler() {
    //     let statusOfFirstEnvoie = cart[0]['type'];
    //     if (cart.some(item => item.type !== statusOfFirstEnvoie)) {
    //         setErrorBox('Toutes les envois doivent avoir le même Statut');
    //     } else {
    //         setModalAddAction(true)
    //     }
    // }

    function addActionEtatHandler() {
        if (addAgenceDepart.id === 0) {
            setActionErrorBox("Vous devez définir l'agence");
            return;
        }
        if (addNewEnvoieStatus.id === 0) {
            setActionEtatErrorBox("Vous devez définir l'Etat");
            return;
        }
        if (addNewEnvoieStatus.id === 2) { // ACC
            if (cart.some(item => item.typeEnvoie !== 1)) {
                setActionEtatErrorBox("Une de ces Envois n'est pas un Accusé");
                return;
            }
        }
        addActioneEtat(dispatch, cart, addNewEnvoieStatus.id, addMotifNewEnvoieStatus, addAgenceDepart.id,);
    }

    function addActionHandler() {
        // confirm if one of these envois is dead
        if (cart.some(item => item.dead === 1)) {
            setActionErrorBox('Une de ces Envois est terminé');
            return;
        }
        if (addTypeActionEnvoie.id === 0) {
            setActionErrorBox("Vous devez définir le type d'action");
            return;
        }
        if (addAgenceDepart.id === 0) {
            setActionErrorBox("Vous devez définir l'agence de départ");
            return;
        }
        if (addTypeActionEnvoie.id === 3) {
            if (addAgenceArrived.id === 0) {
                setActionErrorBox("Vous devez définir l'agence d'arrivé");
                return;
            }
        }
        if ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5) || (addTypeActionEnvoie.id === 8)) {
            if (addLivreur.id === 0) {
                setActionErrorBox("Vous devez définir le livreur");
                return;
            }
        }
        if ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) {
            if (addTransporteur.id === 0) {
                setActionErrorBox("Vous devez définir le transporteur");
                return;
            }
        }

        if ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5) || (addTypeActionEnvoie.id === 8)) {
            addAction(dispatch, addTypeActionEnvoie.id, cart, addAgenceDepart.id, null, addLivreur.id, addDescription);
            return;
        }
        if ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) {
            if (addTypeActionEnvoie.id === 3) {
                addAction(dispatch, addTypeActionEnvoie.id, cart, addAgenceDepart.id, addAgenceArrived.id, addTransporteur.id, addDescription);
                return;
            }
            addAction(dispatch, addTypeActionEnvoie.id, cart, addAgenceDepart.id, null, addTransporteur.id, addDescription);
            return;
        }

        addAction(dispatch, addTypeActionEnvoie.id, cart, addAgenceDepart.id, null, null, addDescription);
    }

    function formSubmit(e) {
        e.preventDefault();

        if (actionType.id === 1) {
            if (addTypeActionEnvoie.id === 0) {
                setActionErrorBox("Vous devez définir le type d'action");
                return;
            }
            if (addAgenceDepart.id === 0) {
                setActionErrorBox("Vous devez définir l'agence de départ");
                return;
            }
            if (addTypeActionEnvoie.id === 3) {
                if (addAgenceArrived.id === 0) {
                    setActionErrorBox("Vous devez définir l'agence d'arrivé");
                    return;
                }
            }
            if ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5) || (addTypeActionEnvoie.id === 8)) {
                if (addLivreur.id === 0) {
                    setActionErrorBox("Vous devez définir le livreur");
                    return;
                }
            }
            if ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) {
                if (addTransporteur.id === 0) {
                    setActionErrorBox("Vous devez définir le transporteur");
                    return;
                }
            }
            setActionErrorBox("");
        } else {
            if (addAgenceDepart.id === 0) {
                setActionEtatErrorBox("Vous devez définir l'agence");
                return;
            }
            if (addNewEnvoieStatus.id === 0) {
                setActionEtatErrorBox("Vous devez définir l'Etat");
                return;
            }
            if (addNewEnvoieStatus.id === 2) { // ACC
                if (cart.some(item => item.typeEnvoie !== 1)) {
                    setActionEtatErrorBox("Une de ces Envois n'est pas un Accusé");
                    return;
                }
            }
            setActionEtatErrorBox("");
        }



        // var envoieId = codebarCart.slice(4);  // to remove the fisrt four digits (NWE or ACC or RTR or PKP)
        // var envoieType = codebarCart.slice(0, 4);
        // envoieId = envoieId.replace(`${envoieType}00000000`, '');
        // envoieId = envoieId.replace(`${envoieType}0000000`, '');
        // envoieId = envoieId.replace(`${envoieType}000000`, '');
        // envoieId = envoieId.replace(`${envoieType}00000`, '');
        // envoieId = envoieId.replace(`${envoieType}0000`, '');
        // envoieId = envoieId.replace(`${envoieType}000`, '');
        // envoieId = envoieId.replace(`${envoieType}00`, '');
        // envoieId = envoieId.replace(`${envoieType}0`, '');

        var envoieId = codebarCart.slice(4);
        // try {
        //     envoieId = atob(envoieId)
        // } catch (e) {
        //     setErrorBox("Barcode illisible.")
        //     return;
        // }

        if (cart.some(item => item.tracking.toLowerCase() === envoieId.toLowerCase())) {
            setErrorBox('Envoie exist déja dans la cart');
        } else {
            getOneCartEnvoie(dispatch, envoieId, addTypeActionEnvoie.id, user.agence, addNewEnvoieStatus.id);
        }
    }

    const getStatusClass = (statusCode) => {
        if (statusCode === 10) {
            return "preparation"
        } else if (statusCode === 1) {
            return "ramassage"
        } else if (statusCode === 8) {
            return "reception-agence"
        } else if (statusCode === 2) {
            return "depot-agence"
        } else if (statusCode === 3) {
            return "acheminement-depart"
        } else if (statusCode === 4) {
            return "acheminement-arrive"
        } else if (statusCode === 5) {
            return "livraison-domicile"
        } else if (statusCode === 6) {
            return "livraison-agence"
        } else if (statusCode === 9) {
            return "stock-agence"
        } else if (statusCode === 11) {
            return "retour-client"
        }else if (statusCode === 12) {
            return "livre"
        }else {
            return "stock-agence"
        }
    }
    const getTypeClass = (typeCode) => {
        if (typeCode === 1) {
            return "nwe"
        } else if (typeCode === 2) {
            return "livre"
        } else if (typeCode === 3) {
            return "retour"
        } else {
            return "annule"
        }
    }
    const getTypeDelivery = (type) => {
        if (type === 1) {
            return "a-domicile"
        } else if (type === 2) {
            return "en-agence"
        }
    }
    const getTypeEnvoie = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        }
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="action" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Ajouter Action : </span>
                </div>

                <div className="content invoice">
                    <div className={["box", cart.length > 0 ? "inactive" : ""].join(" ")} style={{ margin: "0 auto 30px" }}>
                        <div className="box-content">
                            <FormRadio data={actionTypes} itemChoisir={actionType} setItemChoisir={setActionType} name='tab-action-type' />
                            {
                                actionType.id === 1 ? (
                                    isFetchingAdd ? <SubLoadingComponent /> : (
                                        <form>
                                            {actionErrorBox !== "" && (<div className='box-error'>{actionErrorBox}</div>)}
                                            {
                                                (user.role === 1 || user.role === 2) ? (
                                                    <DropDownComponent data={[{ nom: "Choisir Action", id: 0, }, ...statusEnvois.filter(item => item.id !== 10 && item.id !== 12 && item.id !== 13)]} itemChoisir={addTypeActionEnvoie} setItemChoisir={setAddTypeActionEnvoie} />
                                                ) : (
                                                    <DropDownComponent data={[{ nom: "Choisir Action", id: 0, }, ...statusEnvois.filter(item => item.id !== 10 && item.id !== 7 && item.id !== 12 && item.id !== 13)]} itemChoisir={addTypeActionEnvoie} setItemChoisir={setAddTypeActionEnvoie} />
                                                )
                                            }
                                            {
                                                (addTypeActionEnvoie.id !== 7) && (
                                                    <>
                                                        {
                                                            (user.role === 1 || user.role === 2) ? (
                                                                <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={addAgenceDepart} setItemChoisir={setAddAgenceDepart} filter />
                                                            ) : (
                                                                <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya.filter(item => item.id === user.agence)]} itemChoisir={addAgenceDepart} setItemChoisir={setAddAgenceDepart} filter />
                                                            )
                                                        }
                                                        {
                                                            (addTypeActionEnvoie.id === 3) && (
                                                                <DropDownComponent data={[{ nom: "Choisir Agence Arrivé", id: 0, }, ...agencesByWilaya]} itemChoisir={addAgenceArrived} setItemChoisir={setAddAgenceArrived} filter />
                                                            )
                                                        }
                                                        {
                                                            ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5) || (addTypeActionEnvoie.id === 8)) && (
                                                                <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...(livreurs.filter(item => item.AgenceId === addAgenceDepart.id))]} itemChoisir={addLivreur} setItemChoisir={setAddLivreur} filter />
                                                            )
                                                        }
                                                        {
                                                            ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) && (
                                                                <DropDownComponent data={[{ nom: "Choisir Transporteur", id: 0, }, ...transporteurs]} itemChoisir={addTransporteur} setItemChoisir={setAddTransporteur} filter />
                                                            )
                                                        }
                                                        <FormTextArea label='Description' itemInput={addDescription} setItemInput={setAddDescription} auth />
                                                    </>
                                                )
                                            }
                                        </form>
                                    )
                                ) : (
                                    isFetchingAdd ? <SubLoadingComponent /> : (
                                        <form>
                                            {actionEtatErrorBox !== "" && (<div className='box-error'>{actionEtatErrorBox}</div>)}
                                            {
                                                (user.role === 1 || user.role === 2) ? (
                                                    <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={addAgenceDepart} setItemChoisir={setAddAgenceDepart} filter />
                                                ) : (
                                                    <DropDownComponent data={agencesByWilaya.filter(item => item.id === user.agence)} itemChoisir={addAgenceDepart} setItemChoisir={setAddAgenceDepart} filter />
                                                )
                                            }
                                            <DropDownComponent data={[{ nom: "Choisir nouveau Etat", id: 0, }, ...currentStatusEnvois.filter(item => item.id !== 1)]} itemChoisir={addNewEnvoieStatus} setItemChoisir={setAddNewEnvoieStatus} />
                                            {
                                                addNewEnvoieStatus.id === 3 && (
                                                    <FormTextArea label='Motif Retour' itemInput={addMotifNewEnvoieStatus} setItemInput={setAddMotifNewEnvoieStatus} auth />
                                                )
                                            }
                                        </form>
                                    )
                                )
                            }

                        </div>
                    </div>
                </div>

                <form onSubmit={(e) => formSubmit(e)} className='barcode'>
                    <label htmlFor="barcode" >Barcode</label>
                    <input type="text" onChange={e => setCodebarCart(e.target.value)} value={codebarCart} autoFocus />
                    <label style={{ marginTop: '10px', fontSize: 19 }} htmlFor="barcode" >vous sélectionnez : {cart.length}</label>
                </form>

                {errorBox !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorBox}</div>)}

                {cart.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                    : (
                        <>
                            <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='actions/create' />
                            <div className="content">
                                {
                                    <>
                                        <TableComponent headers={[cart.length === 0 ? '' : <span className='mini-th'>{cart.length}</span>, 'Tracking', "Expéditeur", "Statut", "Agence Actuelle", "Type d'Envoie", "Type Dépot", "Type Livraison", "Wilaya Départ", "Wilaya d'Arrivé", 'Date', 'Action']}>
                                            {
                                                tinyCart.map((ele, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {
                                                                (ele.dead === 1) && (
                                                                    <span className="tooltip">
                                                                        <span className="material-symbols-rounded" style={{ color: "#00c02c" }}>lock</span>
                                                                        <span className="tooltip-text on">Cette Envoie est terminé</span>
                                                                    </span>
                                                                )
                                                            }
                                                            <span className="tooltip">
                                                                <span className={["material-symbols-rounded tooltip-icon", ele.isCostPaid === 1 ? 'on' : 'off'].join(' ')} style={{ transform: "scale(1.1)" }}>campaign</span>
                                                                {
                                                                    ele.isCostPaid === 1 ? (
                                                                        <span className="tooltip-text on">Frais de départ sont payés</span>
                                                                    ) : (
                                                                        <span className="tooltip-text off">Frais de départ non encore payés</span>
                                                                    )
                                                                }
                                                            </span>
                                                            <span className="tooltip">
                                                                <span className={["material-symbols-rounded tooltip-icon", ele.isDeliveryPaid === 1 ? 'on' : 'off'].join(' ')} style={{ transform: "scale(1.1)" }}>campaign</span>
                                                                {
                                                                    ele.isDeliveryPaid === 1 ? (
                                                                        <span className="tooltip-text on">Frais d'arrivé sont payés</span>
                                                                    ) : (
                                                                        <span className="tooltip-text off">Frais d'arrivé non encore payés</span>
                                                                    )
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className={`table-special ${getTypeClass(ele.currentStatus)}`}>{currentStatusEnvois.filter(item => item.id === ele.currentStatus)[0]['nom']}-{ele.tracking}</span>
                                                        </td>
                                                        <td>{ele.EntrepriseId ? ele.Entreprise.nom : ele.User.username}</td>
                                                        <td>
                                                            {
                                                                ele.dead === 1 && ele.type === 5 && (ele.currentStatus === 1 || ele.currentStatus === 2) ? (
                                                                    <span className={`table-special livre`}>Livré Livreur</span>
                                                                ) : (
                                                                    ele.dead === 1 && ele.type === 5 && (ele.currentStatus === 3 || ele.currentStatus === 4) ? (
                                                                        <span className={`table-special retour`}>Livré Livreur</span>
                                                                    ) :
                                                                        <span className={`table-special ${getStatusClass(ele.type)}`}>{statusEnvois.filter(item => item.id === ele.type)[0]['nom']}</span>
                                                                )
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                (ele.Histories[0]['type'] !== 10) ? (
                                                                    ele.Histories[0]['Action']['agenceDepartureActionAlias']['nom']
                                                                ) : ("Pas Encore")
                                                            }
                                                        </td>
                                                        <td>
                                                            <span className={`table-special-border ${getTypeEnvoie(ele.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === ele.typeEnvoie)[0]['nom']}</span>
                                                        </td>
                                                        <td>
                                                            <span className={`table-special ${getTypeDelivery(ele.typeRamassage)}`}>{typeRamassages.filter(item => item.id === ele.typeRamassage)[0]['nom'].slice(6)}</span>
                                                        </td>
                                                        <td>
                                                            <span className={`table-special ${getTypeDelivery(ele.typeDelivery)}`}>{typeDeliveries.filter(item => item.id === ele.typeDelivery)[0]['nom'].slice(10)}</span>
                                                        </td>
                                                        <td>{wilayas.filter(item => item.id === ele.wilayaDeparture)[0]['nom']}</td>
                                                        <td>{wilayas.filter(item => item.id == ele.wilayaArrived)[0]['nom']}</td>
                                                        <td>{ele.createdAt.slice(0, 10)}</td>
                                                        <td>
                                                            <span className='update' onClick={() => navigate(`/envois/detail/${ele.id}`)}>Détail</span>
                                                            <span className='detail' onClick={() => removeOneItem(ele.id)}>Supprimer</span>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </TableComponent>
                                        {
                                            (pages > 1) && (<CartPaginationComponent page={page} pages={pages} item='actions/create' />)
                                        }
                                    </>
                                }
                            </div>
                            <div className="add-item" style={{ marginTop: "25px", marginBottom: "0px", justifyContent: "center" }}>
                                {/* <span className='color-1' onClick={actionType.id === 1 ? addActionHandler : addActionEtatHandler}>Terminer</span> */}
                                <span className='color-1' onClick={() => setModalAddActionActive(true)}>Terminer</span>
                                <span className='color-2' onClick={() => setModalViderPanierActive(true)}>Vider Panier</span>
                            </div>
                        </>
                    )
                }
            </div>

            <ModalComponent modalActive={modalAddActionActive} setModalActive={setModalAddActionActive} setErrorBox={setActionEtatErrorBox} title={actionType.id === 1 ? "Ajouter Action Tracking" : "Ajouter Action Etat"}>
                {
                    <form>
                        <p>Êtes-vous sûr de completer cette Action ?</p>
                        <div className='button' onClick={actionType.id === 1 ? addActionHandler : addActionEtatHandler}>
                            <span>Valider</span>
                        </div>
                    </form>
                }
            </ModalComponent>
            <ModalComponent modalActive={modalViderPanierActive} setModalActive={setModalViderPanierActive} setErrorBox={setActionEtatErrorBox} title={"Vider Panier"}>
                {
                    <form>
                        <p>Êtes-vous sûr vous voulez vider le panier ?</p>
                        <div className='button' onClick={viderPanier}>
                            <span>Valider</span>
                        </div>
                    </form>
                }
            </ModalComponent>
        </div>
    )
}

export default CreateAction
